import { render, staticRenderFns } from "./ProductsCollection.vue?vue&type=template&id=fe8d250a&"
import script from "./ProductsCollection.vue?vue&type=script&lang=js&"
export * from "./ProductsCollection.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCollection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports